import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class CloudiaIcon extends BaseIcon {
  getChildren = () => [<path fill={ this.getColor() }
                             d='M619.5 321c82.5 6 148.5 75 148.5 159 0 88.5-72 160.5-160.5 160.5h-415.5c-106.5 0-192-85.5-192-192 0-99 75-180 171-190.5 40.5-76.5 120-130.5 213-130.5 117 0 213 82.5 235.5 193.5z'/>]
  getViewBox = () => '0 0 768 768'
}
